module.exports = __webpack_public_path__ + "static/img/08-人大附中经济开发区学校.3a97a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/08-人大附中经济开发区学校.png
// module id = Zg1d
// module chunks = 0